import * as React from 'react';
import { PageWrap } from '../../layouts';
import { theme } from '../../theme';
import { H1, H3 } from '../../typography';
import Button from './Button';

type ErrorFallbackProps = {};

const ErrorFallback: React.FC<ErrorFallbackProps> = props => {
  const redirect = () => {
    if (window.location.pathname.includes('service-provider')) {
      window.location.href = '/service-provider';
    } else if (window.location.pathname.includes('funder')) {
      window.location.href = '/funder';
    } else if (window.location.pathname.includes('admin')) {
      window.location.href = '/admin';
    }
  };

  return (
    <PageWrap
      height="calc(100vh / var(--ib-ui-scale, 1))"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <H1 mb={4} color="primary">
        Oops, an error has occurred!
      </H1>
      <H3>It has been reported and will be attended to, please refresh your browser.</H3>
      <Button
        my={4}
        bg={theme.colors.primary}
        width="200px"
        type="button"
        color="white"
        text="Go Home"
        onClick={() => redirect()}
      />
    </PageWrap>
  );
};

export default ErrorFallback;
